import styled from '@emotion/styled';
import { Button, Card, InputLabel, MenuItem, Select, Typography, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import Separator from 'ui-component/Separator';
import ScrollCol from 'ui-component/ScrollCol2';
import { supportedChains, useWallet } from 'hooks/useWallet';
import chains from 'data/chains';
import { css, withTheme } from '@emotion/react';
import { ethers } from 'ethers';
import useContract from 'hooks/useContract';
import toast from 'utils/toast';

const Traverse = () => {
  const { provider, chainId } = useWallet();
  const [tokenId, setTokenId] = useState(0);
  const [destination, setDestination] = useState(supportedChains[0]);
  const contract = useContract();

  const traverse = async () => {
    const estimation = await contract.estimateFees(chains[destination].lzChainId, tokenId);
    await contract
      .traverseChains(chains[destination].lzChainId, tokenId, { value: estimation })
      .then((tx) => tx.wait())
      .then(() => toast.success('Transfer queued'))
      .catch((err) => toast.error(err.message));
  };

  return (
    <StyledCard variant="outlined">
      <TopLeft>
        <div>
          <Typography variant="h1"> Traverse </Typography>
          <Separator />
        </div>
        <Typography variant="h2">
          Make sure you are on the source network <br />
          <br />
          Input the tokenId of the NFT you want to traverse <br />
          <br />
          Select the destination chain. <br />
          <br />
          And click on TRAVERSE to send your NFT on the destination chain
        </Typography>
      </TopLeft>
      <TopRight>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Input value={tokenId} id="outlined-number" label="TokenID" type="number" onChange={(event) => setTokenId(event.target.value)} />
          <Select
            sx={{ width: '50%' }}
            value={destination}
            label="Destination Chain"
            onChange={(event) => setDestination(event.target.value)}
          >
            {console.log(chainId)}
            {supportedChains.map((chainId) => (
              <MenuItem key={chainId} value={chainId}>
                {chains[chainId].displayName}
              </MenuItem>
            ))}
          </Select>
        </div>

        <TraverseBtn variant="contained">
          <Typography onClick={() => traverse()} variant="h2">
            TRAVERSE
          </Typography>
        </TraverseBtn>
      </TopRight>
    </StyledCard>
  );
};

const Input = styled(TextField)`
  & > label {
    color: white;
  }
`;

const StyledScroll = styled(ScrollCol)`
  max-width: 40%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const NftCard = withTheme(styled.img`
  width: 150px;
  margin: 10px;
  cursor: pointer;
  ${(props) =>
    props.selected
      ? css`
          border: 4px solid ${props.theme.palette.secondary.main};
        `
      : css`
          border: 4px solid white;
        `}
`);

const TopRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 250px;
  width: 40%;
  & > * {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TopLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 250px;
  width: 40%;
  & > * {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TraverseBtn = styled(Button)`
  width: 100%;
  height: 50px;
  align-self: center;
  background-color: #c20e02;
  border: 2px solid white;
`;

const StyledCard = styled(Card)`
  background-color: #131822;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 50px;
  margin: 20px;
  border: 2px solid white;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  width: 100%;
  min-height: 600px;

  @media (max-width: 425px) {
    padding: 20px;
  }
`;

export default Traverse;
